<template>
    <div
        class="note"
        :class="{
            'pinned': pinned,
        }"
    >
        <div v-if="canEdit || canPin" class="pin">
            <a v-if="canPin" @click="onTogglePin(index)">
                <i
                    class ="fas fa-thumbtack"
                    :class="{ 'fa-rotate-45': !pinned, 'text-danger': pinned }"
                    :title="__(pinned ? 'Unpin This Post' : 'Pin This Post')"
                ></i>
            </a>

            <a v-if="canEdit" @click="onEdit(index)">
                <i
                    class="fas fa-pencil-alt"
                    :title="__('Edit This Post')"
                ></i>
            </a>
        </div>

        <div class="dateTime">{{ formattedDate }}</div>
        <div class="user"> {{ __('by') }} {{ user.username }}</div>

        <div v-if="canEdit" class="delete">
            <a @click="onDelete(index)" :title="__('Delete')">&times;</a>
        </div>

        <div class="body">{{ body }}</div>
    </div>
</template>

<script>
const dateFns = require('date-fns');

const { format, parse } = dateFns;

export default {
    name: "EnqNote",

    props: {
        body: {
            required: true,
            type: String
        },

        dateTime: {
            required: true,
            type: String
        },

        user: {
            required: true,
            type: Object
        },

        index: {
            required: true,
            type: Number
        },

        pinned: {
            required: true,
            type: Boolean
        },

        canPin: {
            required: true,
            type: Boolean
        },

        canEdit: {
            required: true,
            type: Boolean
        },

        onTogglePin: {
            required: true,
            type: Function
        },

        onEdit: {
            required: true,
            type: Function
        },

        onDelete: {
            required: true,
            type: Function
        },

        iconPath: {
            required: true,
            type: String
        }
    },

    data() {
        return {};
    },

    computed: {
        formattedDate() {
            const p = parse(
                this.dateTime,
                "yyyy-MM-dd HH:mm:ss",
                new Date()
            );

            return p.toLocaleDateString() + ' @ ' + format(p, 'HH:mm:ss');
        }
    },

    methods: {},

    watch: {}
};
</script>
